


<!-- <ngx-pull-to-refresh
    class="w-full"
	spinnerColor="#ff0000"
  spinnerSize="50"
	distanceForRefresh="200"
	[isEnable]="true"
	(refresh)="myRefreshEvent($event, 'refresh')"
	> -->
    <router-outlet></router-outlet>
<!-- </ngx-pull-to-refresh> -->